import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const failedSavingPositiveKeywords = ReducerUtils.createReducer(false,{
  [Actions.FAILED_SAVING_POSITIVE_KEYWORDS] : (state,action)=>action.status
})

export default failedSavingPositiveKeywords
